// R007 参与中态卡片切图资源常量（来自 on-progress.rd-ui.v4.json 的 assetKey）。
// 复用 v3 已上传的美团 CDN（venus）链接，不重复上传。源切图见 .d2c/193157689797261/exports/0519-组件优化_4/。
export const PROGRESS_CARD_ASSET = {
    /** 规则入口右箭头 向右 */
    RULE_ARROW: 'https://img.meituan.net/makerjiulv/b2b755bdbc52d51f69a4c24206552730667.png',
    /** 进度+操作面板底图（圆角+顶部尖角） bg */
    PANEL_BG: 'https://p0.meituan.net/ingee/21e8e307de472a63434d063908a6e8737999.png',
    /** 手举¥288 角标 小手 */
    HAND_BADGE: 'https://img.meituan.net/makerjiulv/914a23ccd7a0cfeeb1ae23f3555530d125627.png',
    /** 看奖励图标 奖励 */
    REWARD_ICON: 'https://img.meituan.net/makerjiulv/d495a4496fd0f23061c3a0463dc24a4b1751.png',
    /** 做任务图标 路径 */
    TASK_ICON: 'https://img.meituan.net/makerjiulv/c65ecf5cd8bd847d49802f8a5760ab631866.png',
    /** 热门游玩灵感 分隔标题 周边推荐 */
    LANDMARK_HEADER: 'https://img.meituan.net/makerjiulv/291aa20cd960972aab099f90ada1d3674601.png'
};
